<template>
  <transition name="fade">
    <modal @close-modal="$emit('close-modal')">
      <div
        class="bg-white px-12 py-8 grid justify-center justify-items-center w-96 rounded-md text-center"
      >
        <img src="../assets/upload-failed.svg" alt="Error" width="108" height="102" />
        <p class="text-2xl font-bold mt-16">{{ errorPopupMessage?.message.primary }}</p>
        <p>{{ errorPopupMessage?.message.primaryMsgSecLang }}</p>
        <div class="mt-6 grid gap-4">
          <custom-button
            variant="primary"
            type="button"
            @click="$emit('close-modal')"
            :disabled="loading"
          >{{ `${errorPopupMessage?.message.primaryButtonTextEng}/${errorPopupMessage?.message.primaryButtonTextSecLang}` }}</custom-button>
          <custom-button
            v-if="errorPopupMessage.continueAnyway"
            variant="secondary"
            :loading="loading"
            @click="applicationContinueAnyway"
          >{{ `${errorPopupMessage?.message.continueAnywayTextEng}/${errorPopupMessage?.message.continueAnywayTextSecLang}` }}</custom-button>
        </div>
      </div>
    </modal>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import Modal from './Modal.vue';
import CustomButton from './CustomButton.vue';

export default {
  name: 'ErrorMessagePopup',
  components: {
    Modal,
    CustomButton,
  },
  computed: {
    ...mapGetters(['applicationId']),
  },
  props: {
    errorPopupMessage: {
      required: true,
      type: Object,
    },
    routeLink: {
      required: true,
      type: String,
    },
    actionButtonText: {
      required: true,
      type: String,
    },
    defaultContinueAnyways: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      loading: undefined,
    };
  },
  methods: {
    applicationContinueAnyway() {
      if (this.defaultContinueAnyways) {
        this.loading = true;
        this.$store
          .dispatch('applicationContinueAnyway', {
            applicationId: this.applicationId,
            queryParams: {
              review: !!this.$route.meta.isEdit,
            },
          })
          .then(() => {
            this.loading = false;
            this.$router.push({ name: this.routeLink });
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.$emit('continue-anyways');
      }
    },
  },
};
</script>
